import React, { useRef, useEffect } from "react";
import { Container } from "reactstrap";
import cn from "classnames";

export default function HubSpotForm({
  customClass,
  form_src,
  form_id,
}) {
  const formContainerRef = useRef(null);
  const formScriptInit = useRef(false);

  useEffect(() => {
    if (formScriptInit.current) return;

    // Dynamically load the HubSpot form script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//js-eu1.hsforms.net/forms/embed/v2.js";
    script.async = true;
    script.onload = () => {
      if (window.hbspt) {
        const escapedId = form_id.match(/^\d/) ? `\\3${form_id[0]} ${form_id.slice(1)}` : form_id;
        window.hbspt.forms.create({
          portalId: "144452896",
          formId: form_id,
          target: `#${escapedId}`,
          onFormSubmitted: function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          },
        });
      }
    };

    formContainerRef.current.appendChild(script);
    formScriptInit.current = true;
  }, [form_src,form_id]);

  return (
    <>
      <section className={cn(customClass, "mt-5")}>
        <Container>
          <div className="hbspt-form" id={form_id} ref={formContainerRef}></div>
        </Container>
      </section>
    </>
  );
}
